'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLeakAdd = function MdLeakAdd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 35c0-6.5 5.1-11.6 11.6-11.6v3.2c-4.6 0-8.4 3.8-8.4 8.4h-3.2z m6.6 0c0-2.7 2.3-5 5-5v5h-5z m-13.4 0c0-10.1 8.3-18.4 18.4-18.4v3.4c-8.3 0-15 6.7-15 15h-3.4z m0-30c0 6.5-5.1 11.6-11.6 11.6v-3.2c4.6 0 8.4-3.8 8.4-8.4h3.2z m6.8 0c0 10.1-8.2 18.4-18.4 18.4v-3.4c8.3 0 15-6.7 15-15h3.4z m-13.4 0c0 2.7-2.3 5-5 5v-5h5z' })
        )
    );
};

exports.default = MdLeakAdd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/leak-add.js
// module id = 1153
// module chunks = 36573943044255 79611799117203 213534597649335